import { useState } from "react";
import { useCustomer } from "../customHooks/useCustomer";
import LoginModal from "../components/Modals/LoginModal/LoginModal";
import StickyNotification from "../components/StickyNotification/StickyNotification";
import ServerError from "../components/ServerError/ServerError";
import HeaderController from "../components/Headers/HeaderController";
import ForgotPasswordModal from "../components/Modals/ForgotPasswordModal/ForgotPasswordModal";
import { useNavigate, useParams } from "react-router-dom";
import { useCartContext } from "../customHooks/useCart";

export default function ProtectedCustomerRoute({ children, shouldHaveCart = true }: { children: any, shouldHaveCart?: boolean }) {
    const [showForgotPasswordModal, setShowForgotPassword] = useState(false);
    const { country, language } = useParams();
    const { getCustomerState } = useCustomer();
    const customerState = getCustomerState();
    const { getSessionFields } = useCartContext();
    const sessionCart = getSessionFields();
    const navigate = useNavigate();
    const isRedirectToShippingPage = window.location.pathname.includes("shipping");
    const [stickyNotificationDetails, setStickyNotificationDetails] = useState({ // global state for sticky handling
        show: false,
        title: "",
        content: "",
        level: "",
        showInfoIcon: true,
        refresh: false,
    });

    const navigationCallback = isRedirectToShippingPage
    ? (exceededCategoryLimit: any, mention: any, cartHasProducts: boolean) => {
      if (cartHasProducts) {
        navigate(`/shipping/${country}/${language}${window.location.search as any}`);
      } else {
        navigate(`/select_treatment/${country}/${language}/${mention}${window.location.search as any}`);
      }
    }
  : () => {};

    if (customerState?.customerID) {
        return children;
    } else if (shouldHaveCart && !sessionCart.id) {
        return (
            <>
                <HeaderController showSteps={false} stage={"Questionnaire"} />
                <ServerError status={404} />
            </>
        )
    }
    else {
        return (
            <>
                {/* Funnel header like the other logged-out pages; its language toggle syncs the CH language from the URL for the modal texts */}
                <HeaderController showSteps={false} stage={"Shipping"} />
                <StickyNotification
                    showNotification={stickyNotificationDetails.show}
                    title={stickyNotificationDetails.title}
                    onClick={() => setStickyNotificationDetails((currentDetails: any) => { return { ...currentDetails, show: false } })}
                    content={stickyNotificationDetails.content}
                    level={stickyNotificationDetails.level}
                    showInfoIcon={stickyNotificationDetails.showInfoIcon}
                    refresh={stickyNotificationDetails.refresh}
                />

                <LoginModal
                    setStickyNotificationDetails={setStickyNotificationDetails}
                    closeModal={() => { }}
                    closeable={false}
                    navigationCallback={navigationCallback}
                    showForgotPasswordOption={true}
                    changeShowForgotPassword ={(boolValue:any) => {setShowForgotPassword(boolValue)}}
                    language={language}
                    country={country}
                    redirectPath={window.location.pathname + window.location.search as any}
                    cameFromPath={window.location.pathname + window.location.search as any}
                />

                {showForgotPasswordModal && language && (
                    <ForgotPasswordModal
                        closeModal={() => setShowForgotPassword(false)}
                        language={language}
                        setStickyNotificationDetails={setStickyNotificationDetails}
                    />
                )}
            </>
        )
    }
};